const initState = {
  daily: [],
  weekly: [],
  monthly: [],
};

const analyticsInfoReducer = (state = initState, action) => {
  switch (action.type) {
    case "DAILY_ANALYTICS_FETCH":
      return {
        ...state,
        daily: action.payload,
      };
    case "WEEKLY_ANALYTICS_FETCH":
      return {
        ...state,
        weekly: action.payload,
      };
    case "MONTHLY_ANALYTICS_FETCH":
      return {
        ...state,
        monthly: action.payload,
      };
    default:
      return state;
  }
};

export default analyticsInfoReducer;
